import { forwardRef } from 'react'
import clsx from 'clsx'

import { IData } from './data'

import styles from './course-text-block.module.scss'

interface CourseTextBlockProps {
  data: IData
  modificator?: string
}

const CourseTextBlock = forwardRef<HTMLDivElement, CourseTextBlockProps>(
  ({ data, modificator }, ref) => {
    const { title, textParagraphs } = data
    return (
      <div
        className={clsx(styles.container, {
          [modificator as string]: modificator,
        })}
        ref={ref}
      >
        {title && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.wrap}>
          {textParagraphs.map((txt) => (
            <p className={styles.txt} key={txt} dangerouslySetInnerHTML={{ __html: txt }}></p>
          ))}
        </div>
      </div>
    )
  }
)

CourseTextBlock.displayName = 'CourseTextBlock'

export default CourseTextBlock
